<template>
  <div class="swiper">
    <div class="swiper-wrapper">
      <div class="swiper-slide"><SliderA /></div>
      <div class="swiper-slide"><SliderB /></div>
      <div class="swiper-slide"><SliderC /></div>
      <div class="swiper-slide"><SliderD /></div>
      <div class="swiper-slide"><SliderE /></div>
      <div class="swiper-slide"><SliderF /></div>
      <div class="swiper-slide"><SliderG /></div>
      <div class="swiper-slide"><SliderH /></div>
      <div class="swiper-slide"><SliderI /></div>
      <div class="swiper-slide"><SliderJ /></div>
    </div>
    <CopyRight />
  </div>
</template>

<script>
import CopyRight from "./components/CopyRight.vue";
import SliderA from "./sliders/SliderA.vue";
import SliderB from "./sliders/SliderB.vue";
import SliderC from "./sliders/SliderC.vue";
import SliderD from "./sliders/SliderD.vue";
import SliderE from "./sliders/SliderE.vue";
import SliderF from "./sliders/SliderF.vue";
import SliderG from "./sliders/SliderG.vue";
import SliderH from "./sliders/SliderH.vue";
import SliderI from "./sliders/SliderI.vue";
import SliderJ from "./sliders/SliderJ.vue";

export default {
  name: "App",
  computed: {
    options() {
      return {
        direction: "vertical",
        pagination: false,
        thresholdDistance: "10",
      };
    },
  },
  mounted() {
    new Swiper(".swiper", {
      direction: "vertical",
    });
  },
  components: {
    CopyRight,
    SliderA,
    SliderB,
    SliderC,
    SliderD,
    SliderE,
    SliderF,
    SliderG,
    SliderH,
    SliderI,
    SliderJ,
  },
};
</script>

<style lang="less" scoped>
.swiper {
  height: 100%;
  overflow: hidden;
}
</style>
